import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import "./header.css";

const cachedPic =
  localStorage.getItem("cachedPic") ||
  auth.currentUser?.photoURL ||
  "/defaultProfile.png";

function Header() {
  const [userRaw, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const location = useLocation();

  const [profilePic, setProfilePic] = useState(cachedPic);
  const [isSignedIn, setIsSignedIn] = useState(!!auth.currentUser);

  useEffect(() => {
    if (!userRaw && !loading) {
      setProfilePic("/defaultProfile.png");
      setIsSignedIn(false);
      localStorage.removeItem("cachedPic");
      return;
    }

    if (userRaw) {
      setIsSignedIn(true);
      const docRef = doc(db, "users", userRaw.uid);
      const unsubscribe = onSnapshot(docRef, (docSnap) => {
        const data = docSnap.data();
        const pic =
          data?.profilePic || userRaw.photoURL || "/defaultProfile.png";

        setProfilePic(pic);
        localStorage.setItem("cachedPic", pic);
      });
      return () => unsubscribe();
    }
  }, [userRaw, loading]);

  const handleLogout = () => {
    auth.signOut();
    setIsSignedIn(false);
    navigate("/");
  };

  return (
    <header className="header-wrapper">
      <div className="header-left">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            if (location.pathname === "/") {
              window.location.reload();
            } else {
              navigate("/");
            }
          }}
          className="logo-link"
          aria-label="Mindly Home"
        >
          <img id="logo" src="/mindlyLogo.png" alt="Mindly Logo" />
        </a>
      </div>

      <div className="header-right-group">
        <nav className="nav-links">
          <NavLink
            to="/mission"
            className={({ isActive }) => (isActive ? "active-link" : undefined)}
            onClick={(e) => {
              e.preventDefault();
              if (location.pathname !== "/mission") navigate("/mission");
            }}
          >
            Mission
          </NavLink>
          <NavLink
            to="/team"
            className={({ isActive }) => (isActive ? "active-link" : undefined)}
            onClick={(e) => {
              e.preventDefault();
              if (location.pathname !== "/team") navigate("/team");
            }}
          >
            Team
          </NavLink>
        </nav>

        <div className="header-right">
          {isSignedIn ? (
            <div className="user-dropdown">
              <button className="user-button">
                <img
                  src={profilePic}
                  alt="User Avatar"
                  className="user-avatar"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/defaultProfile.png";
                  }}
                />
              </button>
              <div className="dropdown-menu">
                <button onClick={() => navigate("/profile")}>Profile</button>
                <button onClick={handleLogout}>Log out</button>
              </div>
            </div>
          ) : (
            !loading && (
              <button className="auth-btn" onClick={() => navigate("/authpage")}>
                Log In / Sign Up
              </button>
            )
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
